import React from 'react'
import { Card, Row } from 'antd'
import CONSTANTS from '../../../util/constant/CONSTANTS'
import Heading from '../../../component/common/Heading'
import CRUDComponent from '../../../component/common/CRUD-Component'
import moment from 'moment'
import { useNavigate } from 'react-router-dom'

const Pets = () => {
    const navigate = useNavigate()
    return (
        <>
            <div className='my-5'>
                <Card>
                    <Heading>Pets</Heading>

                    <Row>
                        <CRUDComponent
                            GET={{
                                API: CONSTANTS.API.Pet.getAll,
                                DataModifier: (res, API, Setrefresh) => {
                                    // console.log(res, "GET ALL ABCD");
                                    return res?.map(data => {
                                        return {
                                            ...data,
                                            no: `P${data?.id.toString().padStart(7, "0")}`,
                                            user: data?.user?.name || '-',
                                            dob: moment(data?.dob).format("DD MMM YYYY"),
                                            isBlocked: {
                                                checked: !data?.isBlock,
                                                id: data?.id,
                                                onClick: (id, val) => {
                                                    const UpdateAPIEnd = { ...CONSTANTS?.API.Pet.update };
                                                    UpdateAPIEnd.endpoint = `${UpdateAPIEnd?.endpoint}${id}`;
                                                    API.sendRequest(
                                                        UpdateAPIEnd,
                                                        () => {
                                                            Setrefresh((prev) => !prev);
                                                        },
                                                        { isBlock: val },
                                                        `Pet ${val ? "Blocked" : "Unblocked"} Successfully`
                                                    );
                                                },
                                                // onClick: () => { }
                                            },
                                            view: {
                                                id: data?.id,
                                                onClick: () => {
                                                    navigate(`/app/pets/${data?.id}`)
                                                }
                                            }
                                        }
                                    })
                                },
                                column: CONSTANTS.TABLE.PETS,
                            }}
                            isSearch={true}
                        />
                    </Row>

                </Card>
            </div>


        </>
    )
}

export default Pets